import { Farm, Farmer, IrrigationSource, ServiceType } from "@agroyaar/sdk";
import { LeadingExpert } from "../../../../../../features/my-colleagues/domain/my-colleagues.interface";
import ExpertInformation from "../common/ExpertInformation";
import FarmerInformation from "../common/FarmerInformation";
import FarmInformation from "../common/FarmInformation";
import IrrigationSourceInformation from "../common/IrrigationSourceInformation";
import SeasonInformation from "../common/SeasonInformation";
import Divider from "../Divider";
import FooterIntroduction from "./FooterIntroduction";
import HeaderIntroduction from "./HeaderIntroduction";
import Intro from "./Intro";
import { Season } from "../../../../../../features/growing-season/domain/growing-season.interface";

interface IntroductionProps {
  serviceType: ServiceType;
  farmer: Farmer;
  farm?: Farm;
  season?: Season;
  irrigationSource?: IrrigationSource;
  leadingExpert?: LeadingExpert;
  introDes?: JSX.Element;
}

const Introduction = ({
  serviceType,
  farmer,
  leadingExpert,
  farm,
  season,
  irrigationSource,
  introDes,
}: IntroductionProps) => {
  return (
    <section
      id="introduction"
      className="flex flex-col items-center w-full h-[1048px]"
    >
      <HeaderIntroduction serviceType={serviceType} />

      <div className="flex flex-col justify-between items-center w-full">
        <Intro serviceType={serviceType} introDes={introDes} />

        <Divider serviceType={serviceType} />

        <div className="flex justify-start items-center w-full gap-[20px] px-4">
          <FarmerInformation farmer={farmer} serviceType={serviceType} />
          {leadingExpert && (
            <ExpertInformation
              leadingExpert={leadingExpert}
              serviceType={serviceType}
            />
          )}
        </div>

        <Divider serviceType={serviceType} />

        <div className="flex justify-start items-start w-full gap-[20px] px-4">
          {irrigationSource && (
            <IrrigationSourceInformation irrigationSource={irrigationSource} serviceType={serviceType} />
          )}
          {farm && <FarmInformation farm={farm} serviceType={serviceType} />}
          {season && (
            <SeasonInformation season={season} serviceType={serviceType} />
          )}
        </div>

        <div className="w-full">
          <Divider serviceType={serviceType} />
        </div>
      </div>

      <FooterIntroduction
        serviceType={serviceType}
        footerCaption="W  W  W  .  A  G  R  O  Y  A  A  R  .  C  O  M"
      />
    </section>
  );
};

export default Introduction;
